import { pxToRem } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const Container = styled.div `
  width: 100%;
  max-width: ${pxToRem(300)};
  margin: 0 auto;
`;
